import { computed, observable } from 'mobx';

import { EVENTS } from './constants';

class MembershipEventStore {
  @observable events = [];
  @observable loaded = false;

  @computed
  get hasSparkleCampaignSettingsEvent() {
    return this.events.includes(EVENTS.SPARKLE_CAMPAIGN_SETTINGS);
  }

  hasCampaignEvent = (eventName) => {
    return this.events.includes(eventName);
  };
}

export default new MembershipEventStore();
